import { FolderView } from '../../../myArmyList/common/ArmyListView';
import { FormView, FormViewParams } from '../../common/view/FormView';

export class FolderEditView extends FormView {
  folder: FolderView;
  folders: Array<FolderView>;

  constructor(params: FolderEditViewParams) {
    super(params);
    this.folder = params.folder;
    this.folders = params.folders;
  }
}

export type FolderEditViewParams = FormViewParams & {
  folder: FolderView;
  folders: Array<FolderView>;
};
